import React, { Suspense } from 'react';
import CustomThemeProvider from './configuration/CustomThemeProvider';
import RouteConfiguration from './routes/RouteConfiguration';
import { Box, Typography } from '@mui/material';
import { Authenticator, View } from '@aws-amplify/ui-react';
import store from './store/Store';
import { Provider } from 'react-redux';
import { PermissionsProvider } from './context/PermissionsContext/PermissionsContext';
import { ThemeProvider } from './context/PermissionsContext/ThemeContext/ThemeContext';
import './configuration/AmplifyConfiguration';
import '@aws-amplify/ui-react/styles.css';
import './Application.css';
import ApplicationStateBootstrap from './configuration/ApplicationStateBootstrap';
import './Internationalization';
import CenteredProgress from './components/CenteredProgress';
import { ToastContainer, toast } from 'react-toastify';
import styled from '@emotion/styled';
import 'react-toastify/dist/ReactToastify.minimal.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
const StyledToastContainer = styled(ToastContainer)`
  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  &&&.Toastify__toast-container {
    background-color: transparent;
    box-shadow: none;
    padding: 0;
  }
  .Toastify__toast {
    background-color: transparent;
    box-shadow: none;
    padding: 0;
  }
  .Toastify__toast-body {
    background-color: transparent;
    box-shadow: none;
    padding: 0;
  }
  .Toastify__progress-bar {
    margin: 0px;
    padding: 0px;
    border-radius: 0px;
  }
`;

const components = {
  Header() {
    return (
      <View style={{ justifyContent: 'center' }}>
        <View
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            background: 'transparent',
            marginLeft: '32px',
            marginTop: '32px',
          }}
        >
          <img src="/images/paiv-logo.png" alt="Gamify" />
        </View>
        <View style={{ paddingTop: 22 }}>
          <Typography
            sx={{
              color: '#222428',
              textAlign: 'left',
              fontSize: 32,
              fontFamily: 'Manrope',
              fontWeight: 'bold',
              marginLeft: '32px',
            }}
          >
            Welcome back
          </Typography>
          <Typography
            sx={{
              textAlign: 'left',
              fontSize: 16,
              fontFamily: 'Manrope',
              marginLeft: '32px',
            }}
          >
            Log in to your account
          </Typography>
        </View>
      </View>
    );
  },
};

global.toast = toast;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

class Application extends React.Component {
  constructor(props) {
    super(props);
    // NOTE: this.state.isLogged is set in ApplicationStateBootstrap which is why this is passed to that component as a prop. This state variable is needed to dynamically change the app's styliing for when a user isn't logged in (log in screen) vs. when a user is logged in (rest of the app)
    this.state = {
      isLoggedIn: !!global.me, // Initial state based on global.me
    };
  }

  render() {
    // console.log(
    //   'LOG IN STYLING this.state?.isLoggedIn: ',
    //   this.state?.isLoggedIn
    // );

    return (
      <Box
        style={
          this.state?.isLoggedIn
            ? {}
            : {
                height: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '32px',
              }
        }
      >
        <QueryClientProvider client={queryClient}>
          <Box
            style={
              this.state?.isLoggedIn
                ? {}
                : {
                    border: '1px solid #D7D9D6',
                    borderRadius: 16,
                    width: 'fit-content',
                  }
            }
          >
            <Authenticator
              components={components}
              loginMechanisms={['email']}
              hideSignUp={true}
            >
              <PermissionsProvider>
                <Provider store={store}>
                  <ThemeProvider>
                    <CustomThemeProvider>
                      <Suspense fallback={<CenteredProgress />}>
                        <ApplicationStateBootstrap this={this}>
                          <Box>
                            <RouteConfiguration />
                          </Box>
                          <StyledToastContainer />
                        </ApplicationStateBootstrap>
                      </Suspense>
                    </CustomThemeProvider>
                  </ThemeProvider>
                </Provider>
              </PermissionsProvider>
            </Authenticator>
          </Box>
          {!this.state?.isLoggedIn && (
            <Box
              style={{
                border: '1px solid #D7D9D6',
                borderRadius: 16,
                padding: '32px',
                width: '400px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                backgroundColor: 'white',
              }}
            >
              <Typography
                sx={{
                  color: '#222428',
                  fontSize: 24,
                  fontFamily: 'Manrope',
                  fontWeight: 'bold',
                  marginBottom: '24px',
                  textAlign: 'center',
                }}
              >
                Download the Paiv App
              </Typography>

              <Box
                style={{
                  display: 'flex',
                  gap: '24px',
                  justifyContent: 'center',
                  width: '100%',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                  }}
                >
                  <Box
                    style={{
                      width: '150px',
                      height: '150px',
                      border: '1px solid #D7D9D6',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'white',
                    }}
                  >
                    <img
                      src="https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=https://apps.apple.com/us/app/paiv-win-on-the-go/id1577406696"
                      alt="App Store QR Code"
                      style={{ width: '140px', height: '140px' }}
                    />
                  </Box>
                  <a
                    href="https://apps.apple.com/us/app/paiv-win-on-the-go/id1577406696"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <img
                      src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                      alt="Download on App Store"
                      style={{ height: '40px', cursor: 'pointer' }}
                    />
                  </a>
                </Box>

                <Box
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '12px',
                  }}
                >
                  <Box
                    style={{
                      width: '150px',
                      height: '150px',
                      border: '1px solid #D7D9D6',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'white',
                    }}
                  >
                    <img
                      src="https://api.qrserver.com/v1/create-qr-code/?size=140x140&data=https://play.google.com/store/apps/details?id=com.gogamify.app"
                      alt="Google Play QR Code"
                      style={{ width: '140px', height: '140px' }}
                    />
                  </Box>
                  <a
                    href="https://play.google.com/store/apps/details?id=com.gogamify.app"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: 'none' }}
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                      alt="Get it on Google Play"
                      style={{ height: '40px', cursor: 'pointer' }}
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.parentElement.innerHTML =
                          '<div style="background: black; color: white; padding: 8px 16px; border-radius: 4px; font-family: Manrope; font-size: 14px; cursor: pointer;">GET IT ON<br/><strong>Google Play</strong></div>';
                      }}
                    />
                  </a>
                </Box>
              </Box>
            </Box>
          )}
        </QueryClientProvider>
      </Box>
    );
  }
}

export default Application;
